module.exports = __webpack_public_path__ + "f89586986445c200f27ac021235c75dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/pages/HomePage2/PrintTypes/digital.jpg
// module id = 862
// module chunks = 1